export function createApiError(error: unknown): Error {
  const errorObject =
    typeof error === 'object' && error !== null ? (error as Record<string, unknown>) : undefined;

  const nestedDetail =
    typeof errorObject?.detail === 'object' && errorObject.detail !== null
      ? (errorObject.detail as Record<string, unknown>)
      : undefined;

  const message =
    (typeof nestedDetail?.detail === 'string' && nestedDetail.detail) ||
    (typeof errorObject?.message === 'string' && errorObject.message) ||
    (typeof errorObject?.detail === 'string' && errorObject.detail) ||
    'An unexpected error occurred';

  const err = new Error(message);
  (err as { detail?: unknown }).detail = error;
  return err;
}

/**
 * Read the HTTP status out of an API error body. The backend envelope carries
 * it as `status_code`, either at the root or nested under `detail` (see
 * app/infrastructure/middleware/exception_handlers.py) — the generated client
 * throws that body rather than the Response, so the status is only readable here.
 */
export function extractStatusCode(error: unknown): number | undefined {
  const body =
    typeof error === 'object' && error !== null ? (error as Record<string, unknown>) : undefined;

  if (typeof body?.status_code === 'number') {
    return body.status_code;
  }

  const nestedDetail =
    typeof body?.detail === 'object' && body.detail !== null
      ? (body.detail as Record<string, unknown>)
      : undefined;

  return typeof nestedDetail?.status_code === 'number' ? nestedDetail.status_code : undefined;
}

export function extractStatus(error: unknown): number | undefined {
  if (typeof error === 'object' && error !== null && 'status' in error) {
    const maybeStatus = (error as { status?: unknown }).status;
    if (typeof maybeStatus === 'number') {
      return maybeStatus;
    }
  }

  return undefined;
}
